<div>
  <evsb-label *ngIf="label" [label]="label.label" [name]="name" [className]="label?.className"></evsb-label>
  <input
    type="email"
    class="body-small py-4 px-6 border border-grey focus:border-grey-dark60 focus:outline-none rounded-2xl w-full"
    [id]="id"
    [class]="className"
    [class.border-error]="error?.error"
    [placeholder]="placeholder"
    [(ngModel)]="value"
  />
  <evsb-error *ngIf="error" class="block mt-2" [error]="error.error" [className]="error?.className"></evsb-error>
</div>
